import { MLV_PII_BLOCKLIST } from './mlvEvents.js';
import { mlvAnalyticsLog } from './mlvAnalytics.js';
import { mlvSentryBreadcrumb } from './mlvSentry.js';
import { mlvClarityEvent } from './mlvClarity.js';

/**
 * Sanitiza params: descarta PII y recorta strings largos.
 * GA4 limita: 25 params por evento, value <= 100 chars (string).
 */
function sanitizeParams(params) {
  const out = {};
  if (!params || typeof params !== 'object') return out;
  let count = 0;
  for (const [k, v] of Object.entries(params)) {
    if (count >= 25) break;
    const key = String(k).toLowerCase();
    if (MLV_PII_BLOCKLIST.some((p) => key.includes(p))) continue;
    if (v === undefined || v === null) continue;
    if (typeof v === 'object') continue;
    if (typeof v === 'string') {
      out[k] = v.length > 100 ? v.slice(0, 100) : v;
    } else if (typeof v === 'number' || typeof v === 'boolean') {
      out[k] = v;
    }
    count++;
  }
  return out;
}

/**
 * Telemetría unificada. Despacha el evento a:
 *   1) `window.mlvTrack` (hook externo; p.ej. GTM custom).
 *   2) `CustomEvent` `mlv-analytics` (compatibilidad histórica).
 *   3) Firebase Analytics (GA4).
 *   4) Sentry breadcrumb (aparece como contexto si hay un error después).
 *   5) Clarity custom event (aparece como filtro de sesiones).
 *
 * No lanza; no bloquea UI.
 */
export function mlvTrack(name, params = {}) {
  const safe = sanitizeParams(params);

  try {
    if (typeof window !== 'undefined' && typeof window.mlvTrack === 'function') {
      window.mlvTrack(name, safe);
    }
  } catch (_e) {
    /* ignore */
  }
  try {
    if (typeof document !== 'undefined') {
      document.documentElement.dispatchEvent(
        new CustomEvent('mlv-analytics', { detail: { name, params: safe }, bubbles: true })
      );
    }
  } catch (_e) {
    /* ignore */
  }
  try {
    mlvAnalyticsLog(name, safe);
  } catch (_e) {
    /* ignore */
  }
  try {
    mlvSentryBreadcrumb(name, safe);
  } catch (_e) {
    /* ignore */
  }
  try {
    mlvClarityEvent(name);
  } catch (_e) {
    /* ignore */
  }
}
